export const FACEBOOK_SCOPES =
  'email,public_profile,pages_show_list,pages_read_engagement,pages_manage_posts';
